/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';

class Thumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.file = props.file;

    this.file.helper.on('thumbnailLoaded', () => {
      this.forceUpdate();
    });
  }

  render() {
    let helper = this.file.helper;
    return (
      <img
        src={helper.featuredUrl(800)}
        style={{borderRadius: 5, width: '100%'}}
      />
    );
  }
}

export default Thumbnail;
